import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ROLES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/loanRoles`,
  {
    GET_LOAN_ROLES: 'GET_LOAN_ROLES',
    GET_LOAN_ROLES_HISTORY: 'GET_LOAN_ROLES_HISTORY',
    CREATE_LOAN_ROLE_ASSIGNMENT: 'CREATE_LOAN_ROLE_ASSIGNMENT',
    EDIT_LOAN_ROLE_ASSIGNMENT: 'EDIT_LOAN_ROLE_ASSIGNMENT',
    DELETE_LOAN_ROLE_ASSIGNMENT: 'DELETE_LOAN_ROLE_ASSIGNMENT',
  },
);
